import React from "react";
import cellEditFactory from "react-bootstrap-table2-editor";
import BootstrapTable from "react-bootstrap-table-next";

import "./orderPickingProductTable.scss";
import { CutLink } from "components/CutLink";
import { useNomenclatureModal } from "contexts/NomenclatureModalContext";

export const OrderPickingProductTable = ({ products = [] }) => {
  const { openNomenclatureModal } = useNomenclatureModal();
  const tableProductsColumns = [
    {
      dataField: "index",
      text: "№",
      headerStyle: (colum, colIndex) => {
        return { width: "2%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "provider",
      text: "Поставщик",
      headerStyle: (colum, colIndex) => {
        return { width: "16%" };
      },
      formatter: (cell, row) => row.provider?.name,
      editable: false,
      footer: () => null,
    },
    {
      dataField: "name",
      text: "Наименование",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.name}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "brand",
      text: "Бренд",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.brand}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "article",
      text: "Артикул",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.article}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "count",
      text: "Кол-во",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      headerClasses: () => "right",
      footerClasses: () => "right",
      classes: () => "right",
    },
    {
      dataField: "",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "40%" };
      },
      editable: false,
      footer: (columnData) => <></>,
    },
  ];

  return (
    <>
      <BootstrapTable
        wrapperClasses="order-picking-product"
        keyField="id"
        data={products}
        columns={tableProductsColumns}
        bootstrap4
        bordered={false}
      />
    </>
  );
};
